/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Password_PlaceholderInputs */

const en_user_password_placeholder = /** @type {(inputs: User_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`********`)
};

const ja_user_password_placeholder = /** @type {(inputs: User_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`********`)
};

const fr_user_password_placeholder = /** @type {(inputs: User_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`********`)
};

const de_user_password_placeholder = /** @type {(inputs: User_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`********`)
};

/**
* | output |
* | --- |
* | "********" |
*
* @param {User_Password_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_password_placeholder = /** @type {((inputs?: User_Password_PlaceholderInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Password_PlaceholderInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_password_placeholder(inputs)
	if (locale === "ja") return ja_user_password_placeholder(inputs)
	if (locale === "fr") return fr_user_password_placeholder(inputs)
	return de_user_password_placeholder(inputs)
});